import { StyledFormGroup } from "../styled-form-group";
import { NumericInput } from "@blueprintjs/core";
import React from "react";
import "styled-components/macro";
import _ from "lodash";

export function NumTicketsInput({
  formState,
  formActions,
  activeField,
  setActiveField,
  data_testid,
  helperText,
  label,
  isVisible = true,
}) {
  return !isVisible ? null : (
    <StyledFormGroup
      helperText={helperText}
      label={label}
      labelFor="numTickets"
      activeField={activeField}
      css={`
        margin-left: 48px;
      `}
    >
      <div>
        <div className={"bp3-control-group bp3-large"}>
          <NumericInput
            data-testid={data_testid}
            name="numTickets"
            value={formState.numTickets}
            onValueChange={(v) => formActions.setNumTickets(_.isNaN(v) ? 0 : v)}
            buttonPosition={"none"}
            leftIcon="shopping-cart"
            large
            onFocus={() => setActiveField("numTickets")}
            css={`
              input {
                width: 146px !important;
              }
            `}
          />
          <div
            className={"bp3-input bp3-minimal bp3-large"}
            css={`
              width: 68px;
            `}
          >
            tickets
          </div>
        </div>
      </div>
    </StyledFormGroup>
  );
}
